"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
var _utils = require("../../middleware/utils");
function generatePayload(values) {
  var payload = {};
  var {
    isSingleLife,
    isNewYork,
    singleLifeArray,
    jointLifeArray,
    nySingleArray,
    nyJointArray
  } = values;
  var selectedArray = [];
  if (isSingleLife === 'singleLife' && isNewYork === 'otherState') {
    singleLifeArray.map(object => {
      selectedArray.push([parseInt(object.endAge), parseFloat(object.withdrawalRate)]);
    });
  } else if (isSingleLife === 'jointLife' && isNewYork === 'otherState') {
    jointLifeArray.map(object => {
      selectedArray.push([parseInt(object.endAge), parseFloat(object.withdrawalRate)]);
    });
  } else if (isSingleLife === 'singleLife' && isNewYork === 'newYork') {
    nySingleArray.map(object => {
      selectedArray.push([parseInt(object.endAge), parseFloat(object.withdrawalRate)]);
    });
  } else if (isSingleLife === 'jointLife' && isNewYork === 'newYork') {
    nyJointArray.map(object => {
      selectedArray.push([parseInt(object.endAge), parseFloat(object.withdrawalRate)]);
    });
  }

  /* istanbul ignore next */
  function setFieldIfExists(fieldName, value, forcedValue) {
    if (value !== '' && value !== undefined) {
      payload[fieldName] = value;
    } else if (forcedValue || forcedValue === 0) {
      payload[fieldName] = forcedValue;
    }
  }
  var rollUpRateMap = {
    '3%': 3,
    '4%': 4,
    '5%': 5,
    '6%': 6,
    '7%': 7
  };
  var rollUpPeriodMap = {
    '0 years': 0,
    '1 year': 1,
    '2 years': 2,
    '3 years': 3,
    '4 years': 4,
    '5 years': 5,
    '6 years': 6,
    '7 years': 7,
    '8 years': 8,
    '9 years': 9,
    '10 years': 10,
    '11 years': 11,
    '12 years': 12,
    '13 years': 13,
    '14 years': 14,
    '15 years': 15
  };
  var interestRollUpMap = {
    Simple: 'Simple',
    Compound: 'Compound'
  };
  var glwbVersionMap = {
    singleLife: 'Single Life',
    jointLife: 'Joint Life'
  };
  var clientLocationMap = {
    newYork: 'new york',
    otherState: 'other state'
  };
  var netMarketGrowthRate = {
    '1.00%': 1.0,
    '1.50%': 1.5,
    '2.00%': 2.0,
    '3.00%': 3.0,
    '2.50%': 2.5,
    '3.50%': 3.5,
    '4.00%': 4.0,
    '4.50%': 4.5,
    '5.00%': 5.0,
    '5.50%': 5.5,
    '6.00%': 6.0,
    '6.50%': 6.5,
    '7.50%': 7.5,
    '7.00%': 7.0,
    '8.00%': 8.0,
    '8.50%': 8.5,
    '9.00%': 9.0,
    '9.50%': 9.5,
    '10.00%': 10.0,
    '11.00%': 11.0,
    '10.50%': 10.5,
    '11.50%': 11.5,
    '12.00%': 12.0
  };

  //   Start all REQUIRED general fields
  //   Required fields are issue_age, purchase_payment, glwb_version, roll_up_rate, roll_up_period, interest_roll_up,
  //   client_location, net_market_growth_rate, competitor_withdrawal_rates
  setFieldIfExists('issue_age', parseInt(values.issueAge));
  setFieldIfExists('purchase_payment', (0, _utils.parseCurrencyString)(null, values.purchasePayment));
  setFieldIfExists('glwb_version', glwbVersionMap[values.isSingleLife]);
  setFieldIfExists('roll_up_rate', rollUpRateMap[values.rollUpRate]);
  setFieldIfExists('roll_up_period', rollUpPeriodMap[values.rollUpPeriod]);
  setFieldIfExists('interest_roll_up', interestRollUpMap[values.interestRollUp]);
  setFieldIfExists('client_location', clientLocationMap[values.isNewYork]);
  setFieldIfExists('net_market_growth_rate', netMarketGrowthRate[values.net_market_growth_rate]);
  setFieldIfExists('competitor_withdrawal_rates', selectedArray);
  return payload;
}